// extracted by mini-css-extract-plugin
module.exports = {"list":"suggest-list_list__21Hjo","title":"suggest-list_title__xp7Zs"};